export default __webpack_public_path__ + "static/media/MP_Profile_Experience_01.fee30172.png";